// @flow

import React from 'react';
import { connect } from 'react-redux';

import { ErrorActions } from '@zapier/toolbox-redux-framework';

type ClearErrorsProps = {
  onClearErrors: () => void,
};

const clearErrors = (Component: () => any) => {
  class ClearErrors extends React.Component<ClearErrorsProps> {
    componentWillUnmount() {
      this.props.onClearErrors();
    }

    render() {
      return <Component {...this.props} />;
    }
  }

  const ConnectedClearErrors = connect(null, (dispatch: Dispatch) => ({
    onClearErrors: () => {
      dispatch(ErrorActions.clearErrors());
    },
  }))(ClearErrors);

  return ConnectedClearErrors;
};

export default clearErrors;
